import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let referrals = useDataValue({
    context: 'appointment_overlay',
    path: 'patient_new.referrals',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    return referrals?.length ? referrals : [{}]
  }, [referrals])
}
